import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ChartOfAccGLCodeLinkContainerModel} from '../../../../../models/aggregates/';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';

@Injectable({
  providedIn: 'root'
})
export class ChartOfAccGLCodeLinkService extends BaseApiTemplateService<ChartOfAccGLCodeLinkContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + "chart-of-acc-glcode-links/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + "chart-of-acc-glcode-links/backoffice-ep";
    this.httpClient = http;
  }
}
